// Spinner.js
import React from 'react';
import styled from 'styled-components';

// Create a styled component for the loader overlay
const LoaderOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Faint background */
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Create a styled component for the loader container
const LoaderContainer = styled.div`
  width: 100px; /* Adjust size of the loading box */
  height: 100px; /* Adjust size of the loading box */
  background-color: white; /* Background color of the loading box */
  border-radius: 10px; /* Rounded corners for the loading box */
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Create a styled component for the loader animation
const LoaderAnimation = styled.div`
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Spinner = () => {
  return (
    <LoaderOverlay>
      <LoaderContainer>
        <LoaderAnimation />
      </LoaderContainer>
    </LoaderOverlay>
  );
};

export default Spinner;
